export enum RolesEnum {
  USER = "user",
  COMPANY_ADMIN = "company_admin",
  APPROVER_1 = "approver_1",
  APPROVER_2 = "approver_2",
  SYSTEM_ADMIN = "system_admin",
}

export enum RolesNameEnum {
  USER = "User",
  COMPANY_ADMIN = "Company Admin",
  APPROVER_1 = "Approver 1",
  APPROVER_2 = "Approver 2",
  SYSTEM_ADMIN = "System Admin",
}

export const orderSortingRole = ["System Admin", "Approver 2", "Approver 1", "Company Admin", "User"];
